import AppointmentCalendarView from './Calendar.vue';

export default AppointmentCalendarView;
